<!-- http://uat-open.epec.com
10.248.0.26    uat-open.epec.com -->
<!--  -->
<template>
  <div class="enquiry-mgt">
    <!-- 搜索 -->
    <div class="container">
      <!-- <tab
        :tabs-value="activeIndex"
        :tab-pane-data="tabArr"
        @tabClick="handleTab"
      /> -->
      <el-form :model="listQuery" class="search-form" size="small" inline>
        <el-form-item label="询价单编号：">
          <el-input v-model.trim="listQuery.enquiryNo" placeholder="请输入询价单编号"></el-input>
        </el-form-item>
        <el-form-item label="询价单名称：">
          <el-input v-model.trim="listQuery.enquiryName" placeholder="请输入询价单名称"></el-input>
        </el-form-item>
        <el-form-item label="询价单状态：" label-width="100px" prop="salesScopeId">
          <el-select v-model="listQuery.enquiryStatus" filterable clearable placeholder="请选择询价单状态">
            <el-option v-for="(val, key) in enquiryStatusObj" :key="key" :label="val" :value="Number(key)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报价截止时间：" label-width="112px" prop="salesScopeId">
          <el-date-picker
            v-model="listQuery.time"
            type="datetimerange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结算方式：" label-width="100px" prop="salesScopeId">
          <el-select v-model="listQuery.isDoC" filterable clearable placeholder="请选择结算方式">
            <el-option v-for="val in payTypeOptions" :key="val.value" :label="val.label" :value="val.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送方式：" label-width="100px" prop="salesScopeId">
          <el-select v-model="listQuery.shipmentType" filterable clearable placeholder="请选择配送方式">
            <el-option
              v-for="val in shipmentTypeOptions"
              :key="val.value"
              :label="val.label"
              :value="val.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="流程节点：" label-width="100px" prop="salesScopeId">
          <el-select
            v-model="listQuery.enquiryStatus"
            filterable
            clearable
            placeholder="请选择流程节点"
          >
            <el-option
              v-for="(val, key) in enquiryStatusObj"
              :key="key"
              :label="val"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div class="search-btn-box">
        <div class="search-reset-btn" style="margin-right: 20px" @click="handleReset">重置</div>
        <div class="search-handle-btn" @click="handleQuery">查询</div>
      </div>
    </div>
    <!-- 操作按钮 -->

    <div class="container">
      <div class="handle-box">
        <!-- <div class="default-btn btn right">导出询价单</div> -->
        <tab :tabs-value="activeIndex" :tab-pane-data="tabArr" @tabClick="handleTab" />
      </div>
      <el-table :data="tableData" border :header-cell-style="{ background: '#F5F5F5' }">
        <el-table-column prop="enquiryNo" label="询价单号" min-width="220" align="center"></el-table-column>
        <el-table-column prop="enquiryName" label="询价单名称" min-width="230" align="center"></el-table-column>
        <!-- <el-table-column label="询价类型" align="center" min-width="100">
              <template slot-scope="scope">
                <span>{{
                  scope.row.enquiryType === 1 ? "公开询价" : "定向询价"
                }}</span>
              </template>
            </el-table-column> -->
        <el-table-column prop="createTime" label="询价发布时间" min-width="180" align="center"></el-table-column>
        <el-table-column prop="quotationDeadline" label="报价截止时间" min-width="180" align="center"></el-table-column>
        <el-table-column prop="flowNode" label="流程节点" min-width="90" align="center"></el-table-column>
        <el-table-column label="询价单状态" min-width="140" align="center">
          <template #default="{ row }">
            <span>{{ enquiryStatusObj[row.enquiryStatus] }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="quotationCount"
          label="流程节点"
          min-width="120"
          align="center"
        ></el-table-column> -->
        <el-table-column label="操作" min-width="280" align="center">
          <template slot-scope="scope">
            <eui-btn
              v-if="activeIndex == 0 && (scope.row.enquiryStatus === 11 || scope.row.enquiryStatus === 12)"
              type="link"
              class="table-handle-btn"
              size="20"
              @click="handleAudit(scope.row)"
            >
              审批
            </eui-btn>
            <eui-btn size="20" type="link" class="table-handle-btn" @click="handleCheckDetail(scope.row)">
              查看详情
            </eui-btn>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from '@/modules/projectA/components/common/e-tabs.vue';
import Api from '@/modules/projectA/api/auditManagement/index';

export default {
  name: 'EnquiryAudit',
  components: { Tab },
  data() {
    const enquiryStatusObj = {
      // 生成订单
      0: '已保存', // 已保存
      1: '待平台审核', // 有
      2: '待报价', // 有
      3: '待揭示', // 有
      4: '已揭示', // 有
      5: '询价完成', // 有
      6: '已下单', // 已下单
      7: '订单完成', // 有
      8: '询价作废', // 没有
      9: '审核拒绝', // 有
      10: '询价过期', // 没有
      11: '待审批',
      12: '选商定价待审批',
      13: '审批拒绝',
      14: '中选通知待确认',
    };
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    return {
      activeIndex: '0',
      tabArr: [
        {
          label: '待审批',
          id: '0',
        },
        {
          label: '已审批',
          id: '1',
        },
      ],
      delayForm: { remark: '', quotationDeadline: '' },
      delayRules: {
        quotationDeadline: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      supplierPriceVisible: false,
      supplierPriceRow: {},

      auditRecordRow: {},
      auditRecordVisible: false,
      // 作废vis
      cancellationVis: false,
      // 询比价状态
      enquiryStatusObj,
      // 询价类型
      enquiryTypeObj,
      productDetail: {},
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        enquiryName: null,
        enquiryNo: null,
        enquiryStatus: null,
        enquiryType: null,
        time: null,
        quotationDeadlineEnd: null,
        quotationDeadlineStart: null,
        auditStatus: 0,
        isDoC: null,
        shipmentType: null,
      },
      total: 0,
      cloneListQuery: {
        pageNum: 1,
        pageSize: 10,
        enquiryName: null,
        enquiryNo: null,
        enquiryStatus: null,
        enquiryType: null,
        time: null,
        quotationDeadlineEnd: null,
        quotationDeadlineStart: null,
        auditStatus: 0,
        isDoC: null,
        shipmentType: null,
      },
      currentIndex: 0,
      tableData: [],
      payTypeOptions: [
        { label: '款到发货', value: 0 },
        { label: '货到付款', value: 1 },
      ],
      shipmentTypeOptions: [
        { label: '卖家自行配送', value: 1 },
        { label: '第三方物流', value: 3 },
      ],
      uniqueId: null,
    };
  },
  computed: {},
  watch: {},
  activated() {
    const time = this.$route.query.t;
    console.log(this.$route.query);
    if (time && time !== this.uniqueId) {
      this.uniqueId = time;
      this.listQuery = {
        pageNum: 1,
        pageSize: 10,
        enquiryName: null,
        enquiryNo: null,
        enquiryStatus: null,
        enquiryType: null,
        time: null,
        quotationDeadlineEnd: null,
        quotationDeadlineStart: null,
        auditStatus: 0,
        isDoC: null,
        shipmentType: null,
      };
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    }
  },
  mounted() {},
  created() {
    this.getList(this.listQuery);
  },
  methods: {
    handleTab(row) {
      this.activeIndex = row.name;
      this.currentIndex = this.activeIndex;
      if (row.name == 0) {
        this.listQuery.auditStatus = 0;
      } else if (row.name == 1) {
        this.listQuery.auditStatus = 1;
      }
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.listQuery.auditStatus = this.currentIndex == 0 ? 0 : 1;
      this.getList(this.listQuery);
    },
    // 搜索
    handleQuery() {
      if (this.listQuery.time?.length) {
        this.listQuery.quotationDeadlineEnd = this.listQuery.time[1];
        this.listQuery.quotationDeadlineStart = this.listQuery.time[0];
      } else {
        delete this.listQuery.quotationDeadlineEnd;
        delete this.listQuery.quotationDeadlineStart;
      }
      // delete this.listQuery.time;
      // for (let item in this.listQuery) {
      //   if (this.listQuery[item] == "") {
      //     this.listQuery[item] = null;
      //   }
      // }

      this.listQuery.auditStatus = this.currentIndex == 0 ? 0 : 1;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    async getList(params) {
      const res = await Api.queryAuditEnquiryListByPage(params);

      if (res.code == '200') {
        this.tableData = res.data ? res.data.records : [];
        this.total = res.data ? res.data.total : 0;
      }
    },
    handleAudit(row) {
      this.$router.push({
        path: '/auditManagement/enquiry/enquiryDetail',
        query: {
          enquiryId: row.enquiryId,
          enquiryStatus: row.enquiryStatus,
          flag: true,
          purchaseCompanyId: row.purchaseCompanyId,
        },
      });
    },
    handleCheckDetail(row) {
      this.$router.push({
        path: '/auditManagement/enquiry/enquiryDetail',
        query: {
          enquiryId: row.enquiryId,
          enquiryStatus: row.enquiryStatus,
          flag: false,
          purchaseCompanyId: row.purchaseCompanyId,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.enquiry-mgt {
  // background: #fff;
  .search-box {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    border-top: 0;
    position: relative;
    top: -1px;
    .search-form {
      ::v-deep .el-input {
        width: 200px;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-date-editor {
        border-radius: 0;
      }
    }
  }
  .search-btn-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;

    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .handle-box {
    // display: flex;
    // justify-content: end;
    margin: 10px 0;
    .default-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right {
      float: right;
    }
  }
  .table-box {
    .table-handle-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .err-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
